import React from 'react';
import './Nav.css'

export default function Nav() {
	return (
		<nav>
			<a href='#about'>about</a>
			<a href='#projects'>projects</a>
			<a href='#contact'>contact</a>
		</nav>
	)
}